import { Box, Grid, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { ReactElement } from 'react';

const BasicIdentification = ({ data }: any): ReactElement => (
  <Box>
    <Grid container spacing={3}>
      <Grid item sm={6} xs={12}>
        <Typography className="mcp-details-title">Server Name</Typography>
        <Typography>{data?.server_name || '-'}</Typography>
      </Grid>
      <Grid item sm={6} xs={12}>
        <Typography className="mcp-details-title">Registry ID</Typography>
        <Typography>MCP-{data?._id?.slice(-8) || '-'}</Typography>
      </Grid>
    </Grid>
    <Grid container spacing={3} mt={1}>
      <Grid item sm={6} xs={12}>
        <Typography className="mcp-details-title">Business Owner</Typography>
        <Typography>{data?.business_owner || '-'}</Typography>
      </Grid>
      <Grid item sm={6} xs={12}>
        <Typography className="mcp-details-title">Technical Owner</Typography>
        <Typography>{data?.technical_owner || '-'}</Typography>
      </Grid>
    </Grid>
    <Grid container spacing={3} mt={1}>
      <Grid item sm={6} xs={12}>
        <Typography className="mcp-details-title">Team / Function</Typography>
        <Typography>{data?.team_or_function || '-'}</Typography>
      </Grid>
      <Grid item sm={6} xs={12}>
        <Typography className="mcp-details-title">Environment Scope</Typography>
        <Typography sx={{ textTransform: 'capitalize' }}>
          {data?.environment_scope || '-'}
        </Typography>
      </Grid>
    </Grid>
    <Grid container spacing={3} mt={1}>
      <Grid item md={6} xs={12}>
        <Typography className="mcp-details-title">Hosting Model</Typography>
        <Typography sx={{ textTransform: 'capitalize' }}>
          {data?.hosting_model || '-'}
        </Typography>
      </Grid>
      <Grid item md={6} xs={12}>
        <Typography className="mcp-details-title">Status</Typography>
        <Typography sx={{ textTransform: 'capitalize' }}>
          {data?.status || '-'}
        </Typography>
      </Grid>
    </Grid>
    <Grid container spacing={3} mt={1}>
      <Grid item sm={12}>
        <Typography className="mcp-details-title">Short Description</Typography>
        <Typography>{data?.short_description || '-'}</Typography>
      </Grid>
    </Grid>
    <Grid container spacing={3} mt={1}>
      <Grid item sm={12}>
        <Typography className="mcp-details-title">Primary Use Cases</Typography>
        <Typography>{data?.primary_use_cases || '-'}</Typography>
      </Grid>
    </Grid>
    <Grid container spacing={3} mt={1}>
      <Grid item sm={12}>
        <Typography className="mcp-details-title">Date Registered</Typography>
        <Typography>
          {dayjs(data.createdAt ?? dayjs()).format('DD/MM/YYYY')}
        </Typography>
      </Grid>
    </Grid>
  </Box>
);

export default BasicIdentification;
